<template>
    <div class="main">
        <div class="app-name">
            <rich-logo></rich-logo>
            <div>
                <h2>Rich'en Danse</h2>
                <p>Espace membre</p>
            </div>
        </div>
        <div class="connexion container">
            <div>
                <router-link style="margin-bottom: 16px;" to="/connexion">Retour</router-link>
                <h1>Réinitialisation du mot de passe</h1>
                <form @submit.prevent="sendRecover" :model="ruleForm" :rules="rules" ref="ruleForm">
                    <uni-input-container label="Adresse e-mail"
                                         id="email"
                    >
                        <uni-input type="email"
                                   id="email"
                                   v-model="ruleForm.email"
                                   :val="ruleForm.email"
                                   required
                                   paceholder="nom@entreprise.fr"
                                   @blur.native="isErrorWithAdress = false"
                        >
                        </uni-input>
                    </uni-input-container>

                    <info-message v-if="isAttemptAnError">
                        Aucun compte n'éxiste avec cette adresse email.
                    </info-message>
                    <info-message status="success" v-if="isEmailSend">
                        Un email de réinitialisation a été envoyé sur votre adresse email.
                    </info-message>

                    <uni-loading-button :is-disable="buttonIsLoading" text="Réinitialiser"/>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import RichLogo from "../../components/a-elements/RichLogo";
    import UniInputContainer from "../../components/a-elements/UniInputContainer";
    import UniInput from "../../components/a-elements/UniInput";
    import UniInputPassword from "../../components/a-elements/UniInputPassword";
    import InfoMessage from "../../components/a-elements/InfoMessage";
    import UniLoadingButton from "../../components/b-patterns/UniLoadingButton";

    export default {
        name: "recoverSend",
        components: {UniLoadingButton, InfoMessage, UniInputPassword, UniInput, UniInputContainer, RichLogo},
        data() {
            return {
                // userWantsToConnect: true,
                buttonIsLoading: false,
                isErrorWithAdress: false,

                isAttemptAnError: false,
                isEmailSend: false,

                ruleForm: {
                    email: '',
                },
                rules: {
                    email: [
                        {
                            type: "email",
                            required: true,
                            message: "Veuillez entrez un email valide.",
                            trigger: 'blur'
                        }
                    ]
                },
                messageType: '',
            }
        },
        methods: {
            sendRecover() {
                this.buttonIsLoading = true

                this.$http.get('/recover-password?email=' + this.ruleForm.email)
                    .then(response => {
                        this.isAttemptAnError = false
                        this.isEmailSend = true
                        this.buttonIsLoading = false
                    })
                    .catch(error => {
                        this.isEmailSend = false
                        this.isAttemptAnError = true
                        this.buttonIsLoading = false
                    })
            }
        },
        created() {
            this.ruleForm.email = this.$route.params.email
        }
    }
</script>

<style lang="scss" scoped>
    .main {
        height: 100vh;
    }


    .connexion {
        max-width: 450px;
        width: 100%;
        margin: 0 auto;
        background: var(--surface-color-light);

        h1 {
            margin-bottom: var(--s-xl);
        }

        &__new {
            margin-top: var(--s-xxl);
            text-align: center;
        }
    }

    .pub {
        display: none;
    }

    .app-name {
        display: flex;
        align-items: center;
        margin-bottom: 32px;
        padding: 8px;

        > div {
            p {
                margin-bottom: 0;
            }

            h2 {
                line-height: 16px;
                margin-bottom: 0;
            }
        }
    }

    .pub-uni {
        position: fixed;
        padding: 8px;
    }

    @include screen-xs {
        .pub-uni {
            padding: 16px;
        }
        .app-name {
            padding: 16px;
        }
    }

    @include screen-l {
        .main {
            .pub-uni {
                bottom: 24px;
                padding: 16px 24px;
            }
        }

        .app-name {
            margin-bottom: 84px;
            padding: 16px 24px;
        }

    }
</style>
